import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HrsectionListComponent } from './hrsection-list/hrsection-list.component';
import { HrsectionCreateComponent } from './hrsection-create/hrsection-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: HrsectionListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: HrsectionCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'hrsection-create/:id',
        component: HrsectionCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRankSectionRoutingModule { }
